<template>
  <form-section
    :title="$t('CampaignForm_Locations_NotificationTrigger_Title')"
    :description="$t('CampaignForm_Locations_NotificationTrigger_Desc')"
    :separator="true"
    :is-changed="model.diff && model.diff.includes('locationTrigger')"
  >
    <form-item prop="location_trigger">
      <radio-group v-model="location_trigger" inline>
        <radio
          :border="true"
          :label="1"
          :title="
            $t('CampaignForm_Locations_NotificationTrigger_OnEnter_Title')
          "
          :description="
            $t('CampaignForm_Locations_NotificationTrigger_OnEnter_Desc')
          "
        />
        <radio
          :border="true"
          :label="2"
          :title="$t('CampaignForm_Locations_NotificationTrigger_OnExit_Title')"
          :description="
            $t('CampaignForm_Locations_NotificationTrigger_OnExit_Desc')
          "
        />
        <radio-custom :border="true" :label="3">
          <div :class="{ title: true, 'title-active': location_trigger === 3 }">
            {{
              $t('CampaignForm_Locations_NotificationTrigger_AfterDwell_Title')
            }}
          </div>
          <div v-if="location_trigger === 3" class="radio-input">
            <div class="input-description">
              {{
                $t(
                  'CampaignForm_Locations_NotificationTrigger_AfterDwell_TriggerAfter'
                )
              }}
            </div>
            <el-input-number
              v-model="location_dwell_time"
              controls-position="right"
              size="small"
              class="dwell-input"
              :placeholder="
                $t(
                  'CampaignForm_Locations_NotificationTrigger_AfterDwell_Placeholder'
                )
              "
              :min="1"
              :max="30"
            />
          </div>
          <div class="description" v-else>
            {{
              $t('CampaignForm_Locations_NotificationTrigger_AfterDwell_Desc')
            }}
          </div>
        </radio-custom>
      </radio-group>
    </form-item>
  </form-section>
</template>

<script>
import FormSection from '@/common/components/form/FormSection'
import FormItem from '@/common/components/form/FormItem'
import RadioGroup from '@/common/components/form/RadioGroup'
import Radio from '@/common/components/form/Radio'
import RadioCustom from '@/modules/campaign-manage/components/locations/RadioCustom'

export default {
  name: 'NotificationTrigger',
  components: { RadioCustom, Radio, RadioGroup, FormItem, FormSection },
  props: {
    model: {
      type: Object
    }
  },

  data() {
    return {
      location_trigger: this.model.location_trigger || 1,
      location_dwell_time: this.model.location_dwell_time || undefined
    }
  },

  watch: {
    location_trigger: function(value) {
      this.model.location_trigger = value
    },

    location_dwell_time: function(value) {
      this.model.location_dwell_time = value
    }
  }
}
</script>

<style scoped>
.after-dwell-time {
  margin-top: 20px;
}

.radio-input {
  display: flex;
  align-items: center;
}

>>> .el-form-item__label {
  font-weight: 600;
  line-height: 22px;
  font-size: 16px;
}

>>> .el-radio {
  height: unset !important;
  min-height: 80px !important;
  max-height: 120px !important;
  white-space: unset;
}

>>> .el-form-item {
  margin-bottom: 0;
}

.title,
>>> .title {
  font-weight: 600;
  line-height: 22px;
  color: #5c6374;
}

.description {
  color: #7e8596;
  font-size: 12px;
}

.input-description {
  margin-right: 10px;
  color: #7e8596;
  font-size: 12px;
}

.title-active {
  margin-bottom: -7px;
}

.dwell-input {
  width: 170px;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/locations/NotificationTrigger.vue